import { FC, useContext } from "react";
import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";
import MegaMenuHeader from "@app/layout/menus/MegaMenuHeader";
import MegaMenuLink from "@app/layout/menus/MegaMenuLink";
import MegaMenuStandardLink from "@app/layout/menus/MegaMenuStandardLink";

//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
const DataMenu: FC = () => {
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;

  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Data" />
        <ul className="menu">
          {
            featureFlags.has(Features.NEW_PROVIDER_MANAGEMENT_UI) ?
              <MegaMenuLink menuItem={MenuItemEnum.Providers} faIcon="user-md" to={`/provider-sets/manager`} linkText="Providers" />
              : <MegaMenuStandardLink menuItem={MenuItemEnum.Providers} faIcon="user-md" to={`${window.uiEndpoint}/Data/ProviderSets`} linkText="Providers" />
          }
          <MegaMenuLink menuItem={MenuItemEnum.Members} faIcon="users" to={`/member-populations`} linkText="Member Populations" />
          <RoleRestricted allowedRoles={[Roles.CLIENT_ADMIN, Roles.QUEST_ADMIN]}>
            <MegaMenuStandardLink menuItem={MenuItemEnum.Censuses} faIcon="user" to={`${window.uiEndpoint}/Data/Censuses`} linkText="Censuses" />
          </RoleRestricted>
        </ul>
      </li>
    </ul>
  );
}

export default DataMenu;